import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["disabled", "type"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }

import { Component, withDefaults, computed, ref } from "vue"
import { isString, cn } from "@/shared/utils/helpers"

interface Props {
    type?: "button" | "submit" | "reset"
    disabled?: boolean
    emitIconsClick?: boolean
    styleType?: "primary" | "secondary" | "danger" | "active" | "underlined" | "simple"
    iconStart?: Component
    iconEnd?: Component
    classes?: string[]
    iconClasses?: string[]
    small?: boolean
    buttonText?: string
    isIconOnly?: boolean
    isMenuActionItems?: boolean
    buttonTextColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsButton',
  props: {
    type: { default: "button" },
    disabled: { type: Boolean, default: false },
    emitIconsClick: { type: Boolean, default: false },
    styleType: { default: "primary" },
    iconStart: {},
    iconEnd: {},
    classes: { default: () => [] },
    iconClasses: { default: () => [] },
    small: { type: Boolean, default: true },
    buttonText: {},
    isIconOnly: { type: Boolean, default: false },
    isMenuActionItems: { type: Boolean, default: false },
    buttonTextColor: { default: "text-gray-700" }
  },
  emits: ["clickIconStart", "clickIconEnd"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emits = __emit

const button = ref<HTMLElement>()

const props = __props

function clickEndIcon(event: Event) {
    event.stopPropagation()
    emits("clickIconEnd")
}

const iconClass = computed(() =>
    props.styleType === "primary"
        ? "text-white"
        : props.styleType === "active"
        ? "text-primary-color-600"
        : "text-gray-400"
)

const buttonSmallClass = computed(() => (props.small ? "h-[38px] text-sm" : "text-base"))
const buttonDisabledClass = computed(() => (props.disabled ? "opacity-40 cursor-not-allowed" : ""))
const buttonIconStartClass = computed(() =>
    props.iconStart && !props.isIconOnly ? "pl-10" : props.isIconOnly ? "pl-5" : ""
)
const buttonIconEndClass = computed(() =>
    props.iconEnd && !props.isIconOnly ? "pr-10" : props.isIconOnly ? "pr-5" : ""
)
const buttonPrimaryClass = computed(() =>
    props.styleType === "primary"
        ? "text-white bg-primary-color-600 hover:bg-primary-color-700 focus:ring-primary-color-500"
        : ""
)
const buttonActiveClass = computed(() => (props.styleType === "active" ? "text-primary-color-600" : ""))
const buttonSecondaryClass = computed(() =>
    props.styleType === "secondary"
        ? "text-gray-700 bg-white hover:bg-gray-200 focus:ring-gray-300 border-1 border-gray-300"
        : ""
)
const buttonDangerClass = computed(() =>
    props.styleType === "danger" ? "text-white bg-red-600 hover:bg-red-700 focus:ring-red-500 border-red-600" : ""
)

const iconEndWrapperClasses = computed(() => [
    props.emitIconsClick ? "" : "pointer-events-none",
    props.small ? "h-[38px]" : "",
    props.isIconOnly ? "flex items-center justify-center" : "absolute inset-y-0 right-0 pr-3 flex items-center",
])

const iconStartWrapperClasses = computed(() => [
    props.emitIconsClick ? "" : "pointer-events-none",
    props.small ? "h-[38px]" : "",
    props.isIconOnly ? "flex items-center justify-center" : "absolute inset-y-0 left-0 pl-3 flex items-center",
])

const buttonUnderlinedClass = computed(() =>
    props.styleType === "underlined"
        ? "bg-transparent text-gray-500 underline underline-offset-4 border-0 !shadow-none"
        : ""
)

const buttonSimpleClass = computed(() =>
    props.styleType === "simple"
        ? `bg-transparent !border-0 !shadow-none ${props.buttonTextColor} ${
              props.isMenuActionItems
                  ? "focus:ring-2 focus:ring-offset-1 focus:ring-primary-color-500 focus:ring-rounded"
                  : "bg-transparent !border-0 !shadow-none focus:ring-transparent focus:!ring-offset-0"
          }`
        : ""
)

__expose({
    buttonEl: button,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref_key: "button",
      ref: button,
      disabled: props.disabled,
      type: props.type,
      class: _normalizeClass([
                buttonDisabledClass.value,
                buttonIconStartClass.value,
                buttonIconEndClass.value,
                buttonPrimaryClass.value,
                buttonActiveClass.value,
                buttonSecondaryClass.value,
                buttonDangerClass.value,
                buttonUnderlinedClass.value,
                buttonSimpleClass.value,
                buttonSmallClass.value,
                _unref(cn)(
                    'w-full flex justify-center items-center py-2 px-4 border rounded-md shadow-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 group',
                    _ctx.classes[0]
                ),
            ])
    }, [
      (props.iconStart)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(iconStartWrapperClasses.value)
          }, [
            (_unref(isString)(props.iconStart))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: props.iconStart,
                  alt: "icon"
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(props.iconStart), {
                  key: 1,
                  class: _normalizeClass([iconClass.value, ...props.iconClasses, 'h-5 w-5'])
                }, null, 8, ["class"]))
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.buttonText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.buttonText), 1))
        : _renderSlot(_ctx.$slots, "default", { key: 2 }),
      (props.iconEnd)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            onClick: clickEndIcon,
            class: _normalizeClass(iconEndWrapperClasses.value)
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(props.iconEnd), {
              class: _normalizeClass([iconClass.value, ...props.iconClasses, 'h-5 w-5'])
            }, null, 8, ["class"]))
          ], 2))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}
}

})